import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import { isEmpty } from "lodash";

const PORTAL_PURCHASE_OPTION = {
  text: "Portal Purchase",
  value: PORTAL_PURCHASE
};

export const selectPrimaryContact = (
  contacts,
  change = () => {},
  handleEmail = () => {}
  // eslint-disable-next-line consistent-return
) => {
  if (!contacts) return null;

  const primaryContact = contacts.filter(c => c.primary)[0];
  if (primaryContact) {
    change(primaryContact.id);
    handleEmail(primaryContact.email);
  }
};

export const contactSelectList = (contacts, allowPortalPurchase = false) => {
  let options = [
    {
      text: "+ Add a Contact",
      value: "Add"
    }
  ];

  const displayEmail = val => (!isEmpty(val) ? ` <${val}>` : null);
  if (allowPortalPurchase) {
    options = options.concat([PORTAL_PURCHASE_OPTION]);
  }
  return contacts
    .map(val => ({
      text: `${val.name}${displayEmail(val.email)}`,
      value: val.id
    }))
    .concat(options);
};



// WEBPACK FOOTER //
// ./app/modules/companies/helpers.js